import {
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { IComboBase } from '../../../interfaces/base/base.interface';
import { ManagementService } from '../../services/management.service';
import { ModalLoadingComponent } from '../../../shared/modals/modal-loading/modal-loading.component';
import { ModalSuccessComponent } from '../../../shared/modals/modal-success/modal-success.component';
import { ModalRejectComponent } from '../../../shared/modals/modal-reject/modal-reject.component';

@Component({
  selector: 'app-jobposition-edit-modal',
  templateUrl: './jobposition-edit-modal.component.html',
  styleUrl: './jobposition-edit-modal.component.scss',
  providers: [DialogService],
})
export class JobpositionEditModalComponent {
  @Input() visible: boolean = false;
  @Input() areaId: number | null = null;
  @Input() jobPositionId: number | null = null;
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() editJobPositionComplete = new EventEmitter<void>();

  isDisabled: boolean = true;
  jobPosition: string | null = null;
  isLoading: boolean = false;
  selectedArea: IComboBase | null = null;
  filteredOptions: IComboBase[] = [];
  areas: IComboBase[] = [];

  hasInteracted: { [key: string]: boolean } = {
    area: false,
    jobPosition: false,
  };

  constructor(
    private managementService: ManagementService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.resetForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes['jobPositionId'] &&
      changes['jobPositionId'].currentValue !== null
    ) {
      this.loadAreaData();
    }
  }

  private loadAreaData(): void {
    this.isLoading = true;
    if (!this.jobPositionId) return;

    this.managementService
      .getJobPositionDetailByJobPositionId(this.jobPositionId)
      .subscribe({
        next: (areaDetailData) => {
          this.areas = [areaDetailData];
          this.selectedArea = {
            key: areaDetailData.areaId,
            text: areaDetailData.areaName,
          };

          this.jobPosition = areaDetailData.jobPositionName;

          this.filteredOptions = this.areas;
          this.hasInteracted['area'] = true;
          this.isLoading = false;
          this.validateForm();
        },
        error: (err) => {
          this.isLoading = false;
          console.error('Error al obtener el área:', err);
        },
      });
  }

  onChangeInput(event: any, type: string) {
    this.hasInteracted[type] = true;
    switch (type) {
      case 'area':
        this.selectedArea = null;
        break;
      case 'jobPosition':
        this.jobPosition = event;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    this.validateForm();
  }

  filterOptions(event: any, type: string) {
    const query = event.query.toLowerCase();
    let options: IComboBase[] = [];
    switch (type) {
      case 'area':
        options = this.areas;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }
    this.filteredOptions = options.filter((option) =>
      option.text.toLowerCase().includes(query)
    );
  }

  onSelect(event: any, type: string) {
    this.hasInteracted[type] = true;

    switch (type) {
      case 'area':
        this.selectedArea = event.value ?? null;
        break;
      default:
        console.error('Tipo no reconocido:', type);
    }

    this.validateForm();
  }

  validateForm() {
    this.isDisabled = !(this.selectedArea && this.jobPosition);
  }

  onSaveChanges() {
    const loadingRef = this.dialogService.open(ModalLoadingComponent, {
      closable: false,
    });

    if (!this.jobPositionId) return;

    const request = {
      areaId: this.areaId,
      nameJobPostion: this.jobPosition,
    };

    const formData = new FormData();

    const appendIfDefined = (key: string, value: any) => {
      if (value !== undefined && value !== null) {
        formData.append(key, value);
      }
    };

    Object.entries(request).forEach(([key, value]) =>
      appendIfDefined(key, value)
    );

    this.managementService
      .updateJobPosition(formData, this.jobPositionId)
      .subscribe({
        next: (response) => {
          loadingRef.close();
          const ref = this.dialogService.open(ModalSuccessComponent, {
            header: '',
            data: {
              text: 'El cargo ha sido actualizado con éxito.',
              title: '¡Éxito!',
              icon: 'pi pi-check-circle',
              showButton: true,
              buttonText: 'Entendido',
            },
          });
          this.editJobPositionComplete.emit();
          this.closeDialog();
        },

        error: (err) => {
          loadingRef.close();

          const ref = this.dialogService.open(ModalRejectComponent, {
            header: '',
            data: {
              text:
                err.error?.error ||
                'Lo sentimos, ocurrió un error. Por favor, inténtelo nuevamente.',
              title: '¡Lo sentimos!',
              showButton: true,
              buttonText: 'Entendido',
            },
          });
          this.resetForm();
          this.closeDialog();
        },
      });
    this.closeDialog();
  }

  resetForm() {
    this.jobPosition = null;
    this.hasInteracted = {
      area: false,
      jobPosition: false,
    };
  }

  closeDialog() {
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }
}
